import { createContext } from 'react';

export const DetailPageLayoutContext = createContext<{ onBack: () => void } | null>(null);
